import { rowHasAudio } from "../../features/survey-management/survey-summary/row-has-audio";
import { surveyorDisplayName } from "../../features/survey-management/survey-summary/surveyor-display-name";

const NESTS = ["meta", "qa", "hierarchy", "sr", "_source", "source"];
const HOURS = ["07", "08", "09", "10", "11", "12", "13", "14", "15", "16", "17", "18", "19", "20"];

export const readField = (row, key) => {
    const direct = row?.[key];
    if (direct !== undefined && direct !== null && direct !== "") return direct;

    for (const nest of NESTS) {
        const value = row?.[nest]?.[key];
        if (value !== undefined && value !== null && value !== "") return value;
    }

    return "";
};

export const surveyorOf = (row) => {
    const surveyorId = readField(row, "surveyor_id") || readField(row, "userid") || readField(row, "user_id");
    return {
        surveyor_id: surveyorId,
        surveyor_name: surveyorDisplayName(row) || surveyorId,
    };
};

export const qaOf = (row) => {
    const status = readField(row, "qa_status");
    if (status === "valid" || status === "invalid") return status;
    return "not-checked";
};

export const highlightOf = (row) => {
    const value = readField(row, "hashighlights");
    if (value === true || value === "true" || value === 1 || value === "1") return "has-hl";
    if (value === false || value === "false" || value === 0 || value === "0") return "no-hl";
    return "not-checked";
};

export const audioOf = (row) => (rowHasAudio(row) ? "has audio" : "no audio");

export const hourOf = (row) => {
    const match = String(readField(row, "dt_start_time") || "").match(/^(\d{1,2})/);
    if (!match) return "";
    const hour = match[1].padStart(2, "0");
    return HOURS.includes(hour) ? `hr_${hour}` : "";
};

export const hourLabels = HOURS;
